import React, { Component } from "react";
import { connect } from "react-redux";

class Explanation extends Component {
  render() {
    return (
      <div>
        <div style={{ marginBottom: "40px" }}>
          <center>
            <font color="#999999">
              <h5>Face recognition and biometric data extraction process</h5>
            </font>
          </center>
        </div>
        <center>
          <div>
            <div style={{ display: "inline-block", margin: "20px" }}>
              <img src={require("../assets/01.png")} alt="01" />
            </div>
            <div style={{ display: "inline-block", margin: "20px" }}>
              <img src={require("../assets/02.png")} alt="02" />
            </div>
            <div style={{ display: "inline-block", margin: "20px" }}>
              <img src={require("../assets/03.png")} alt="03" />
            </div>
            <div style={{ display: "inline-block", margin: "20px" }}>
              <img src={require("../assets/04.png")} alt="04" />
            </div>
          </div>
        </center>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Explanation);



// WEBPACK FOOTER //
// ./src/components/Explanation.js